import { gsap } from 'gsap'
import { CountUp } from 'countup.js'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const initStatistics = () => {
  const statistics = document.querySelectorAll('.stats-home__stat')

  if (!statistics.length) return

  statistics.forEach((statistic) => {
    const startVal = statistic.dataset.startVal || 0
    const endVal = statistic.dataset.endVal
    const prepend = statistic.dataset.prepend
    const append = statistic.dataset.append
		const el = statistic.querySelector('.stats-home__stat-number')
    const count = new CountUp(el, endVal, {
      prefix: prepend,
      suffix: append,
			startVal: startVal,
			separator: '',
      duration: 6
    })

    ScrollTrigger.create({
      trigger: statistic,
      start: 'top 80%',
      end: 'bottom bottom',
      once: true,
      onEnter: () => {
        count.start()
      }
    })
  })
}

export default () => {}
